'use strict';
import React, { Component } from 'react';
import Table from './Table.jsx';
import { GenericModal } from 'com-gyf-webcore-userinterfacecomponents';
import { LogHelper } from 'com-gyf-webcore-loghelper';

class DistribucionLimitesEnterprise extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectLimit: props.data.selectLimit,
            selectAdm: props.data.selectAdm,
            pasoPorEmpresa: props.data.pasoPorEmpresa,
            pasoPorCuenta: props.data.pasoPorCuenta,
            pasoPorTarjeta: props.data.pasoPorTarjeta,
            administradoras: props.data.administradoras,
            empresas: props.data.empresas.slice(),
            cuentas: props.data.cuentas.slice(),
            tarjetas: props.data.tarjetas.slice(),
            novedadesEmpresas: props.data.novedadesEmpresas,
            novedadesCuentas: props.data.novedadesCuentas,
            novedadesTarjetas: props.data.novedadesTarjetas,
            empresasOriginal: props.data.novedadesEmpresasOriginal,
            cuentasOriginal: props.data.novedadesCuentasOriginal,
            tarjetaOriginal: props.data.novedadTarjetaOriginal,
            empresasNoModificadas: props.data.empresasNoModificadas,
            cuentasNoModificadas: props.data.cuentasNoModificadas,
            tarjetasNoModificadas: props.data.tarjetasNoModificadas,
            datosCliente: props.data.datosCliente,
            functions: props.data.functions,
            limiteCliente: props.data.limiteCliente,
            administradoraSeleccionadaId: props.data.administradoraSeleccionadaId,
            seEstaEditando: props.data.seEstaEditando,
            selectCuentasId: props.data.selectCuentasId,
            selectEnterpriseId: props.data.selectEnterpriseId,
            limiteEmpresaExcedido: props.data.limiteEmpresaExcedido,
            //Propiedades de Empresas...
            valorInicialEdicion: undefined,
            valorAnteriorNovedad: undefined,
            editandoLimiteEmpresa: false,
            pressEdit: false,
            seEstaEditando: false,
            selectedId: undefined,
            editadoId: undefined,
            editId: undefined,
        }
    }

    /**
     * Hace aparecer el lapiz en distribucion de limites EMRPESAS.
     * @param {any} id
     */
    aparicionLapizEdicion(id) {
        this.setState({
            selectedId: (this.state.pressEdit != true ? id : this.state.selectedId)
        });
    }

    /**
     * Hace desaparecer el lapiz en distribucion de limites EMRPESAS.
     */
    desaparicionLapizEdicion() {
        this.setState({
            selectedId: (this.state.pressEdit !== true ? undefined : this.state.selectedId)
        });
    }

    /**
     * Es la accion de darlo click al boton del lapiz.
     * @param {any} id
     * @param {any} limiteInicial
     * @param {any} valorAnterior
     */
    comienzoDeEdicion(id, limiteInicial, valorAnterior) {
        this.setState({
            valorInicialEdicion: limiteInicial,
            valorAnteriorNovedad: valorAnterior,
            pressEdit: true,
            editId: id,
            seEstaEditando: true
        }, () => {
            this.actualizarEstadoPadre();
        });
    }

    /**
     * Se realiza el cambio del limite de la emrpesa seleccionada.
     * @param {any} valor
     */
    modificacionLimite(valor) {
        valor = valor.toString() == 'NaN' ? 0 : valor;

        if (valor >= 0 && valor <= 999999999) {
            let empresas = this.state.empresas;
            for (var i = 0; i < empresas.length; i++) {
                if (empresas[i].Id == this.state.selectedId) {
                    empresas[i].LimiteCompra = valor;
                    empresas[i].Editado = true;
                }
            }
            this.setState({
                empresas: empresas,
            }, () => {
                this.actualizarEstadoPadre();
            });
        }
    }

    /**
     * Se realiza el cambio de la novedad de la emrpesa seleccionada.
     * @param {any} valor
     * @param {any} idNovedad
     * @param {any} idRow
     */
    modificacionNovedad(valor, idNovedad, idRow) {
        valor = valor.toString() == 'NaN' ? 0 : valor;

        if (valor >= 0 && valor <= 999999999) {
            let empresas = this.state.empresas;
            let empresaSeleccionadaIndex = this.state.empresas.findIndex(x => x.Id == idRow);
            let novedadesEmpresas = this.state.novedadesEmpresas;
            for (var i = 0; i < novedadesEmpresas.length; i++) {
                if (novedadesEmpresas[i].Id == idNovedad) {
                    novedadesEmpresas[i].ValorNovedad = valor;
                    empresas[empresaSeleccionadaIndex].Editado = true;
                }
            }
            this.setState({
                novedadesEmpresas: novedadesEmpresas,
                empresas: empresas
            }, () => {
                this.actualizarEstadoPadre();
            });
        }
    }

    /**
     * Se acepta la edicion del limite/novedad.
     */
    aceptarEdicion() {
        this.setState({
            editId: undefined,
            editadoId: undefined,
            selectedId: undefined,
            valorInicialEdicion: undefined,
            valorAnteriorNovedad: undefined,
            pressEdit: false,
            seEstaEditando: false
        }, () => {
            this.actualizarEstadoPadre();
        });

    }

    /**
     * Cancela la edicion de limite de la empresa seleccionada.
     * @param {any} id
     */
    cancelEdicionLimite(id) {

        let limiteAnterior = this.state.valorInicialEdicion
        let empresas = this.state.empresas;

        for (var i = 0; i < empresas.length; i++) {
            if (empresas[i].Id == this.state.selectedId) {
                empresas[i].LimiteCompra = limiteAnterior; empresas[i].Editado = false;
            }
        }

        this.setState({
            editId: undefined,
            empresas: empresas,
            editadoId: undefined,
            selectedId: undefined,
            valorInicialEdicion: undefined,
            valorAnteriorNovedad: undefined,
            pressEdit: false,
            seEstaEditando: false
        }, () => {
            this.actualizarEstadoPadre();
        });
    }

    /**
     * Cancela la edicion de limite de la novedad seleccionada.
     * @param {any} id
     * @param {any} idRow
     */
    cancelEdicionNovedad(id, idRow) {
        let empresas = this.state.empresas;
        let empresaSeleccionadaIndex = this.state.empresas.findIndex(x => x.Id == idRow);
        let limiteAnterior = this.state.valorInicialEdicion
        let novedadesEmpresas = this.state.novedadesEmpresas;
        let valorAnterior = this.state.valorAnteriorNovedad;

        for (var i = 0; i < novedadesEmpresas.length; i++) {
            if (novedadesEmpresas[i].Id == id) {
                novedadesEmpresas[i].ValorNovedad = limiteAnterior;
                novedadesEmpresas[i].ValorAnterior = valorAnterior;
                empresas[empresaSeleccionadaIndex].Editado = false;
            }
        }

        this.setState({
            editId: undefined,
            novedadesEmpresas: novedadesEmpresas,
            editadoId: undefined,
            selectedId: undefined,
            valorInicialEdicion: undefined,
            valorAnteriorNovedad: undefined,
            pressEdit: false,
            seEstaEditando: false,
            empresas: empresas
        }, () => {
            this.actualizarEstadoPadre();
        });
    }

    /**
     * Muestra la leyenda de la ultima edición de la novedad seleccionada.
     * @param {any} id
     */
    muestraEditadoNovedad(id) {
        this.setState({ editadoId: id });
    }

    /**
     * Oculta la leyenda de la ultima edición de la novedad seleccionada.
     */
    ocultaEditadoNovedad() {
        this.setState({ editadoId: undefined });
    }

    /**
     * Actualiza los datos del estado del componente padre.
     */
    actualizarEstadoPadre() {
        let estado = {
            empresas: this.state.empresas,
            novedadesEmpresas: this.state.novedadesEmpresas,
            seEstaEditando: this.state.seEstaEditando,
            limiteEmpresaExcedido: this.state.limiteEmpresaExcedido
        }
        this.props.cambiarEstadoEdicion(estado);
    }

    componentDidMount() {
        this.actualizarEstadoPadre();
    }

    render() {
        //Seteo el estado global...
        let data = this.state;

        if (data != undefined) {
            return (
                <div className="container-fluid bottom-separator-xxs">
                    <Table
                        limitesCliente={this.props.limitesCliente}

                        data={data}
                        updateLimitsFunction={this.props.updateLimitsFunction}
                        functions={this.props.functions}
                        internalData={this.props.internalData}
                        editNotifyFn={this.props.editNotifyFn}
                        simulationEditLimitOn={this.props.simulationEditLimitOn}
                        aparicionLapizEdicion={(id) => this.aparicionLapizEdicion(id)}
                        comienzoDeEdicion={(id, valorInicial, valorAnterior) => this.comienzoDeEdicion(id, valorInicial, valorAnterior)}
                        desaparicionLapizEdicion={() => this.desaparicionLapizEdicion()}
                        cancelEdicionLimite={(id) => this.cancelEdicionLimite(id)}
                        cancelEdicionNovedad={(id, idRow) => this.cancelEdicionNovedad(id, idRow)}
                        aceptarEdicion={() => this.aceptarEdicion()}
                        modificacionLimite={(valor) => this.modificacionLimite(valor)}
                        modificacionNovedad={(valor, id, idRow) => this.modificacionNovedad(valor, id, idRow)}
                        muestraEditadoNovedad={(id) => this.muestraEditadoNovedad(id)}
                        ocultaEditadoNovedad={() => this.ocultaEditadoNovedad()} />

                    <GenericModal type={"OK_OTHER"} className="modal fade-out" id={"okModalEnterprise"} onClick={this.aceptModalEnterprise} header={"Advertencia"}
                        body={"Se deben confirmar o descartar los cambios de límite que se iniciaron en la grilla"} />
                </div>
            );
        }
        else {
            return null;
        }
    }
}

export default DistribucionLimitesEnterprise;
